import type { Role } from '@forbiz/contracts'

/**
 * 기업·업체 앱(web)에 들어올 수 있는 역할.
 * OPERATOR(운영자)는 소속(company/vendor)이 없어 이 앱의 화면이 전제로 삼는 데이터가
 * 없다 — 들어오면 페이지가 터진다. 그래서 로그인 폼과 라우트 가드에서 함께 막는다.
 * 운영자 화면은 apps/admin(/admin)에 따로 있다.
 */
export const WEB_ROLES: readonly Role[] = ['COMPANY_ADMIN', 'COMPANY_MEMBER', 'VENDOR_MEMBER']

export function isWebRole(role: Role): boolean {
  return WEB_ROLES.includes(role)
}
